export const extractDeliveryName = (str: string): string => {
    const matches = str.match(/^[^#]+##([^#]+)##(\d+)$/);
    if (!matches || !matches[1] || !matches[2] || !/^\d+$/.test(matches[2])) {
        return str;
    }

    const [, name, number] = matches;
    return `${name} (Option ${number})`;
};
